const initState = {
  subAdmins: [],
};
const subAdminReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_SUB_ADMINS":
      return {
        ...state,
        subAdmins: action.payload,
      };
    case "SUB_ADMIN-REGISTER":
      return {
        ...state,
        subAdmins: [action.payload, ...state.subAdmins],
      };
    case "DELETE_SUB_ADMIN":
      return {
        ...state,
        subAdmins: state.subAdmins.filter(
          (items) => items.id != action.payload
        ),
      };
    case "UPDATE_PERMISSIONS":
      let data = action.payload;
      let newData = state.subAdmins.map((items) =>
        items.id == data.id ? { ...items, ...data } : items
      );
      return {
        ...state,
        subAdmins: newData,
      };

    default:
      return {
        ...state,
      };
  }
};
export default subAdminReducer;
